// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"3e434665","179":"7a535e44","243":"d64357c4","272":"414ac0e7","630":"730b48bc","725":"88a939f5","825":"cbcaa0c0"}[chunkId] + ".chunk.js";
};